/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IProcessClaimsAssignmentConfigurationScope extends angular.IScope {
        model: models.ClaimsAssignmentConfigurationModel;
    }

    export class ProcessClaimsAssignmentConfigurationController implements IController {
        scope: IProcessClaimsAssignmentConfigurationScope;

        constructor(
            $scope: IProcessClaimsAssignmentConfigurationScope,
            claimDefinitionService: services.ClaimDefinitionService,
            claimsAssignmentConfigurationService: services.ClaimsAssignmentConfigurationService,
            processConfigurationService: services.ProcessConfigurationService,
            $routeParams: angular.route.IRouteParamsService,
            treeService: services.TreeService,
            conditionService: services.ConditionService,
            growl: angular.growl.IGrowlService)
        {
            this.scope = $scope;
            this.scope.model = new models.ClaimsAssignmentConfigurationModel(
                ($routeParams["id"]),
                claimsAssignmentConfigurationService,
                claimDefinitionService,
                processConfigurationService,
                treeService,
                conditionService,
                growl);
        }
    }
}

warsApp.registerController('ProcessClaimsAssignmentConfigurationController',
    ['$scope', 'claimDefinitionService', 'claimsAssignmentConfigurationService', 'processConfigurationService', '$routeParams', 'treeService', "conditionService", 'growl']);